<div class="container mx-auto px-4 py-6">
      <!-- Botão do Badge -->
      <button
        (click)="toggleDropdown()"
        (click)="markAsRead()"
        class="relative p-2 rounded-full transition-all duration-200 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        [class.bg-red-50]="hasUnreadAlerts()"
      >
        <lucide-icon [img]="BellIcon" size="22" class="text-gray-600"></lucide-icon>

        <!-- Badge de contagem -->
        @if (alertCount() > 0) {
          <span class="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-bold text-white bg-red-500 rounded-full animate-pulse">
            {{ alertCount() }}
          </span>
        }

        <!-- Indicador de novo alerta -->
        @if (hasUnreadAlerts() && alertCount() === 0) {
          <span class="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
          <span class="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full"></span>
        }
      </button>

      <!-- Dropdown -->
      @if (isOpen()) {
        <div class="absolute right-0 top-12 mt-2 w-[520px] min-h-[500px] bg-white rounded-xl shadow-2xl border border-gray-200 z-50 overflow-hidden">
          <!-- Cabeçalho -->
           <!-- <div class="absolute inset-0 bg-black/50 backdrop-blur-sm " (click)="toggleDropdown()"></div> -->
          <div class="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200">
            <div class="flex items-center gap-2">
              <lucide-icon [img]="BellRingIcon" size="20" class="text-gray-700"></lucide-icon>
              <h3 class="font-semibold text-gray-900">Alertas de Patrulha</h3>
              @if (alertCount() > 0) {
                <span class="px-2 py-0.5 text-xs font-medium bg-red-100 text-red-700 rounded-full">
                  {{ alertCount() }} ativo(s)
                </span>
              }
            </div>
            <div class="flex items-center gap-2">
              <span class="text-xs px-2 py-1 rounded-full" 
                    [class]="isConnected() ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'">
                {{ isConnected() ? 'Online' : 'Offline' }}
              </span>
              <button (click)="toggleDropdown()" class="p-1 hover:bg-gray-200 rounded-lg transition-colors">
                <lucide-icon [img]="XIcon" size="16" class="text-gray-500"></lucide-icon>
              </button>
            </div>
          </div>

          <!-- Lista de Alertas -->
          <div class="overflow-y-auto max-h-[400px] p-3 space-y-2">
            @if (activeAlerts().length === 0) {
              <div class="flex flex-col items-center justify-center py-12 text-center">
                <lucide-icon [img]="CheckCircleIcon" size="48" class="text-green-500 mb-3"></lucide-icon>
                <p class="text-gray-900 font-medium">Nenhum alerta ativo</p>
                <p class="text-sm text-gray-400">Todas as patrulhas estão normais</p>
              </div>
            } @else {
              @for (alert of activeAlerts(); track alert.id) {
                <div class="group border rounded-lg p-3 transition-all duration-200 hover:shadow-md"
                     [class]="getAlertClasses(alert.type)">
                  
                  <!-- Cabeçalho do Alerta -->
                  <div class="flex items-start gap-3">
                    <div class="flex-shrink-0">
                      @if (alert.type === 'no_movement' || alert.type === 'patrol_missing') {
                        <lucide-icon [img]="AlertTriangleIcon" size="24" class="text-red-500"></lucide-icon>
                      } @else {
                        <lucide-icon [img]="AlertCircleIcon" size="24" class="text-orange-500"></lucide-icon>
                      }
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="flex items-start justify-between gap-2">
                        <h4 class="font-semibold text-gray-900 text-sm truncate">
                          {{ alert.title }}
                        </h4>
                        <span class="text-xs text-gray-400 whitespace-nowrap">
                          {{ formatTime(alert.created_at) }}
                        </span>
                      </div>
                      <p class="text-sm text-gray-600 mt-0.5 line-clamp-2">
                        {{ alert.description }}
                      </p>
                      
                      <!-- Metadados -->
                      <div class="flex flex-wrap items-center gap-3 mt-2 text-xs text-gray-500">
                        @if (alert.duration_minutes > 0) {
                          <span class="flex items-center gap-1">
                            <lucide-icon [img]="ClockIcon" size="14"></lucide-icon>
                            {{ alert.duration_minutes }}min sem movimento
                          </span>
                        }
                        @if (alert.position_name) {
                          <span class="flex items-center gap-1">
                            <lucide-icon [img]="MapPinIcon" size="14"></lucide-icon>
                            {{ alert.position_name }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>

                  <!-- Ações -->
                  <div class="flex justify-end mt-2 pt-2 border-t border-gray-100">
                    <button
                      (click)="resolveAlert(alert.id)"
                      class="px-3 py-1 text-xs font-medium text-green-700 bg-green-50 hover:bg-green-100 rounded-lg transition-colors"
                    >
                      <lucide-icon [img]="CheckCircleIcon" size="14" class="inline mr-1"></lucide-icon>
                      Marcar como resolvido
                    </button>
                  </div>
                </div>
              }
            }
          </div>

          <!-- Rodapé -->
          <div class="px-4 py-2 bg-gray-50 border-t border-gray-200 text-center">
            <Button  class="text-sm text-blue-600 hover:text-blue-800 font-medium">
               Alertas Registados
            </Button>
          </div>
        </div>
      }
    </div>